import React from 'react';
import withIcon from '../utilities/withIcon';

const IconClone = () => {
  return (
    <g>
      <path d="m15.1826 5.79h-3.4883v-3.663a.75.75 0 0 0 -.75-.75h-10.1269a.75.75 0 0 0 -.75.75v7.333a.75.75 0 0 0 .75.75h3.4883v3.663a.75.75 0 0 0 .75.75h10.1269a.75.75 0 0 0 .75-.75v-7.333a.75.75 0 0 0 -.75-.75zm-13.6152 2.92v-5.833h8.627v2.913h-5.1387a.75.75 0 0 0 -.75.75v2.17zm12.8652 4.413h-8.6269v-5.833h8.6269z" />
    </g>
  );
};

export default withIcon(IconClone);
